import React, { FC, useState, useEffect } from 'react';
import IconButton from 'src/components/atoms/buttons/IconButton';
import { contentModalDep2ViewStore } from 'src/store/modal';
import _ from 'lodash';
import './style.scss';

interface Props {}

/**
 * Modal 확인 창 레이아웃
 */
const ModalContentDep2Layout: FC<Props> = () => {
  const modalData = contentModalDep2ViewStore((state: any) => state.data);
  const setContentModalState = contentModalDep2ViewStore((state: any) => state.set);
  const closeEvt = () => {
    setContentModalState({
      active: '',
      content: null,
    });
  };
  return (
    <div className={['_modal_content_dep2_layout', modalData.active].join(' ')}>
      <div className="_bg_box" onClick={closeEvt} />
      <div className="_content_box">
        <div className="_content_set" style={modalData.styleDef}>
          <div className="_title_div">
            {modalData.title ? <div className="_title">{modalData.title}</div> : ''}
            <div className="_right_btn">
              <IconButton
                icon="ri-close-line"
                clickEvent={closeEvt}
                styleDef={{ fontSize: '30px', width: '30px', height: '30px' }}
              />
            </div>
          </div>
          <div className="_condtent_div scroll_style">
            <div className="_content ">{modalData.content}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalContentDep2Layout;
